import { useEffect, useState } from "react";
import cs from "classnames";
import PhoneNumber from "./phoneNumber";
import { useValidPhoneNumber } from "../../hooks/useAuthHooks";
import { useTranslation } from "react-i18next";

const Username = ({ usernameIsValid, setUsername }) => {
  const [isPhoneActive, setIsPhoneActive] = useState(false);
  const {
    phoneNumber,
    setPhoneNumber,
    countryCode,
    setCountryCode,
    phoneNumberIsValid,
  } = useValidPhoneNumber("");
  const { t } = useTranslation();

  useEffect(() => {
    setUsername(countryCode.dial_code + phoneNumber);
  }, [phoneNumber, countryCode.dial_code, setUsername]);

  useEffect(() => {
    setUsername("");
    setPhoneNumber("");
  }, [isPhoneActive, setUsername, setPhoneNumber]);

  return (
    <div className="form-group">
      <label>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setIsPhoneActive(false);
          }}
          className={cs("label-phone-number", {
            ["label-active"]: !isPhoneActive,
          })}
        >
          {t("auth.userName.email")}
        </a>{" "}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setIsPhoneActive(true);
          }}
          className={cs("label-phone-number", {
            ["label-active"]: isPhoneActive,
          })}
        >
          / {t("auth.userName.phoneNumber")}
        </a>
      </label>
      {!isPhoneActive ? (
        <input
          type="text"
          onChange={(evt) => {
            setUsername(evt.target.value);
          }}
        />
      ) : (
        <div className="phoneNumberDropdown">
          <PhoneNumber
            phoneNumberIsValid={phoneNumberIsValid}
            setPhoneNumber={setPhoneNumber}
            phoneNumber={phoneNumber}
            countryCode={countryCode}
            setCountryCode={setCountryCode}
          />
        </div>
      )}
      {!usernameIsValid && !isPhoneActive && (
        <div className="valid-message">{t("auth.userName.errorMessage")}</div>
      )}
    </div>
  );
};

export default Username;
